import { Alert, AlertIcon, AlertDescription } from '@/components/v4';

/*
 * Component to show a sucess message
 */
const Succeed = (props) => (
    <Alert status="success">
        <AlertIcon />
        <AlertDescription>{props.message}</AlertDescription>
    </Alert>
);

export default Succeed;
